module.exports = __webpack_public_path__ + "static/media/logowhite.3de34e24.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/logowhite.png
// module id = 59
// module chunks = 0